import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    icon: {
      fontSize: "24px",
      color: "#174176",
    },
    iconButton: {
      padding: 0,
      marginRight: "10px",
      "&:disabled": {
        opacity: 0.8,
      },
    },
    menu: {
      "& .MuiList-padding": {
        padding: "0px",
      },
    },
    textMenu: {
      color: "#5d92f4",
      fontSize: "12pt",
      marginTop: "4px",
    },
    iconButtonMenu: {
      padding: 0,
    },
    marginTopItemMenu: {
      marginTop: "30px",
    },
    modal: {
      maxWidth: "760px",
    },
  })
);

export default useStyles;
